import { useEffect } from "react";
import { Select } from "antd";
import styled from "styled-components";
import URL from "core/resources/urls";
import http from "infra/http";
import useGetInsumos from "../hooks/useGetInsumos";
import type { InsumoSelectPayload } from "../consultarEstoque/types";

interface InsumoSelectProps {
  id: number;
  insumoId: string;
  idExternoUnidade?: string;
  idExternoComponente: string;
  onChange: (payload: InsumoSelectPayload) => void;
  disabled?: boolean;
}

function InsumoSelect({
  id,
  insumoId,
  idExternoUnidade,
  idExternoComponente,
  onChange,
  disabled,
}: InsumoSelectProps) {
  const { data, isLoading } = useGetInsumos(idExternoComponente, idExternoUnidade);

  async function handleChangeInsumo(value: string) {
    const { data: insumoData } = await http.get(
      URL.ORDEM_SERVICO.INSUMO_POR_ID_EXTERNO(value),
    );
    const label = data?.find((opt: { value: string; text: string }) => opt.value === value)?.text;

    onChange({
      insumoIdExterno: value,
      insumoId: insumoData?.insumoId,
      unidade: insumoData?.insumoUnidadeMedidaCodigo,
      insumoUnidadeMedidaDescricao: insumoData?.insumoUnidadeMedidaDescricao,
      insumoLabel: label,
    });
  }

  useEffect(() => {
    if (data && data.length === 1) {
      handleChangeInsumo(data[0].value);
      return;
    }
    if (insumoId) {
      handleChangeInsumo(insumoId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, data, idExternoComponente]);

  return (
    <StyledSelect
      showSearch
      optionFilterProp="text"
      size="large"
      placeholder="Selecione o insumo"
      value={insumoId}
      onChange={e => handleChangeInsumo(e as string)}
      options={data}
      loading={isLoading}
      disabled={isLoading || disabled}
      fieldNames={{ label: "text", value: "value" }}
    />
  );
}

const StyledSelect = styled(Select)`
  width: 100%;

  .ant-select-selector {
    border-radius: 10px !important;
  }
`;

export default InsumoSelect;
